// This file is essentially the index.jsx file for the Forge-fied asset browser
import React, { useMemo } from 'react';
import get from 'lodash/get';
import { createStore, applyMiddleware, compose, Store } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducer from './reducers';
import { ForgeAssetBrowserWrapper } from './ForgeAssetBrowserWrapper';
import type { AssetBrowserProps } from './types';

export const ForgeAssetBrowser = (props: AssetBrowserProps) => {
  const middlewares = useMemo(() => [thunk, ...(props.middlewares || [])], [props.middlewares]);

  const store: Store = useMemo(() => {
    // Use the redux devtool's composeEnhancers to keep them around
    const composeEnhancers =
      (get(window, 'serverConfig.environment') === 'development' &&
        (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
        (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'ForgeAssetBrowser' })) ||
      compose;

    return createStore(reducer(props), composeEnhancers(applyMiddleware(...middlewares)));
  }, [middlewares]);

  return (
    <Provider store={store}>
      <ForgeAssetBrowserWrapper {...props} />
    </Provider>
  );
};
